import styled from "styled-components";

export const StyledParticipant = styled.div`
  position: relative;
  height: 100%;
`;
